import React from 'react';
import classnames from 'classnames';
import styles from './description.module.css';

type DescriptionProps = {
  children: React.ReactNode;
  bold?: boolean;
  className?: string;
};

export const Description = ({
  children,
  bold,
  className,
}: DescriptionProps) => (
  <div
    className={classnames(styles.description, className, {
      [styles.descriptionBold]: bold,
    })}
  >
    {children}
  </div>
);
